module.exports = __webpack_public_path__ + "static/img/1.1.a1f53a57.png";